import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import ColumnToggleMenu from "./ColumnToggleMenu";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
} from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import {
  configActions,
  documentActions,
  msgActions,
} from "../../../../redux/actions";
import MessageWithTruncating from "../../../../components/MessageWithTruncating";

function DocumentsGrid({
  translate,
  tagsIcons,
  docs,
  listFromFileLoaded,
  docsActiveTabs,
  docsInstances,
  docDeliveryData,
  isSender,
  hiddenColumns,
  isExternalUser,
  externalCustomerId,
  docSearch,
  dispatch,
  history,
  handleOpenFullEventClick,
  handleOpenEndpointsClick,
  handleOpenDocsBucketClick,
  handleShowParametersClick,
}) {
  const [fileBBReason, setFileBBReason] = useState(null);
  const [docError, setDocError] = useState(null)

  const handleDocErrorText = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    setDocError(event.currentTarget.value);
  }, [setDocError]);

  const closeDocErrorTextModal = useCallback(() => {
    setDocError(null);
  }, [setDocError]);

  if (docs.length === 0) {
    if (!!listFromFileLoaded) {
      return (
        <div className="empty-text">
          <p>{translate("emptyListFromFileMsg")}</p>
        </div>
      );
    }
    return (
      <div className="empty-text">
        <p>{translate("No documents match the specified filter")}</p>
      </div>
    );
  }
  const delaysErrorStatus = ["VeryLow", "Low", "Medium", "High", "VeryHigh"];

  const closeFileBBReasonsModel = () => {
    setFileBBReason(null);
  };

  const getDeliveryButtonCmp = (doc) => {
    var channelName = "";
    if (doc.deliverydata && doc.deliverydata.length) {
      var errorIndex = -1;
      for (let i = 0; i < doc.deliverydata.length; i++) {
        const docData = doc.deliverydata[i];
        const delayProbability = docData.delayProbability;
        var elementErrorIndex = delayProbability
          ? delaysErrorStatus.indexOf(delayProbability)
          : -1;
        if (elementErrorIndex > errorIndex) {
          channelName = docData.channel;
          errorIndex = elementErrorIndex;
        }
      }
      if (errorIndex > -1) {
        return (
          <div>
            <button
              key={`doc--${doc.docnodeid}`}
              className="btn btn-default btn-circle btn-secondary"
              style={{
                float: "right",
                width: "18px",
                height: "18px",
                margin: "0px 0px 0px 0.5em",
                padding: 0,
                background: "transparent",
                borderColor: "#fff",
              }}
              data-tip
              data-place="bottom"
              data-type="info"
              data-effect="solid"
              data-for={`DelaySeverity-${doc.docnodeid}`}
            >
              <i
                className="fa fa-exclamation"
                style={{
                  fontSize: "0.9em",
                  color: "#fff",
                  boxShadow: "0px 1px 2px 0px rgba(200, 200, 200, 0.8)",
                }}
              />
            </button>
            <ReactTooltip
              key={`doc-tooltip--${doc.docnodeid}`}
              className="customeTheme"
              id={`DelaySeverity-${doc.docnodeid}`}
            >
              <div style={{ textTransform: "none", textAlign: "left" }}>
                <p>{`Channel (${channelName}) has a possible postal delay`}</p>
              </div>
            </ReactTooltip>
          </div>
        );
      }
    }
    return null;
  };

  const isOldDocument = (doc) => {
    const arrivalTime = moment.utc(doc.fileArrivalTs, moment.ISO_8601);
    let _activeFileLimitDate = new Date();
    _activeFileLimitDate.setDate(
      _activeFileLimitDate.getDate() - (window.ActiveFileMaxAgeDays || 2)
    );
    return arrivalTime.toDate().getTime() < _activeFileLimitDate.getTime();
  };

  const handleRowClick = (e, doc, index) => {
    var sel = getSelection().toString();
    if (!sel) {
      let _el = e.target;
      let _action = _el.getAttribute("data-action");
      dispatch(documentActions.setActiveRow(index));
      switch (_action) {
        case "open_flow":
          break;
        default:
          if (!isExternalUser && !isOldDocument(doc)) {
            dispatch(configActions.loadDocsInstances(doc.docnodeid, index));
          }
          const params = {
            uniqueid: doc.docnodeid,
            customerid: doc.customerid,
          };
          dispatch(configActions.loadDocumentDeliveryData(params, index));
          dispatch(documentActions.expandRow(doc.docnodeid));
          break;
      }
    }
  };

  const toggle = (tab, index) => {
    dispatch(configActions.toggleDocsActiveTab(tab, index));
  };

  const handleOpenFlow = (doc) => {
    if (isOldDocument(doc)) {
      dispatch(
        msgActions.error(
          "Document Details",
          "Operational data related to this item has expired"
        )
      );
    } else {
      let qData = {
        id: doc.rooteventid,
        docNr: doc.documentNr,
      };
      var qs = require("qs");
      history.push("/flows?" + qs.stringify(qData));
    }
  };

  const handleOpenFiles = (doc) => {
    let qData = {
      fileId: doc.rooteventid,
    };
    if (doc.fidFs) {
      qData["fidFs"] = doc.fidFs;
    }
    if (docSearch.CustomerId) {
      qData["CustomerId"] = docSearch.CustomerId;
    } else if (isExternalUser) {
      qData["CustomerId"] = externalCustomerId;
    }
    var qs = require("qs");
    history.push("/files?" + qs.stringify(qData));
  };

  const handleOpenReposLink = (doc) => {
    let params = {
      ParkedDocumentUniqueId: doc.docnodeid,
      CustomerId: externalCustomerId,
    };
    var repoLinkWindow = window.open("", "_blank");
    axios.get("Tracking/GetDocRepoUrl", { params: params }).then((response) => {
      var json = response.data;
      if (json.Errors && json.Errors.length) {
        dispatch(
          msgActions.error(
            "Document Repository URL",
            "Server Error: " + json.Errors[0]
          )
        );
      }
      if (json.Data) {
        repoLinkWindow.location.href = json.Data.documentRepoUrl;
      }
    });
  };

  const getChannelDelayIcon = (delayProbability, docnodeid, index) => {
    var elementErrorIndex = delayProbability
      ? delaysErrorStatus.indexOf(delayProbability)
      : -1;
    if (elementErrorIndex > -1) {
      return (
        <span
          style={{
            marginLeft: "0.5em",
            color: "#dc3545",
            fontStyle: "italic",
          }}
        >
          {`${translate(
            delaysErrorStatus[elementErrorIndex]
          )} possibility of the postal delay`}
        </span>
      );
    }
    return null;
  };

  const showBBsReason = (item) => {
    setFileBBReason(
      <ListGroup>
        <ListGroupItem>
          <ListGroupItemHeading>{`${item.chfrom} ${
            item.chfromoperator ? ` (${item.chfromoperator})` : ""
          } -> ${item.chto} ${
            item.chtooperator ? ` (${item.chtooperator})` : ""
          }`}</ListGroupItemHeading>
          <ListGroupItemText>
            <strong>{translate("Code")}: </strong>
            {item.rcode}
            <br />
            <strong>{translate("Reason")}: </strong>
            {item.rmsg && item.rmsg.length > 200 ? (
              <MessageWithTruncating str={item.rmsg} maxLength={200} />
            ) : (
              item.rmsg
            )}
          </ListGroupItemText>
        </ListGroupItem>
      </ListGroup>
    );
  };

  const getBounceBackWarning = (channelItem, docIndex) => {
    const deliveryData = docDeliveryData[docIndex] || [];
    const chDelivery = deliveryData.find(
      (element) =>
        element.Channel === channelItem.channel &&
        ((!element.ChannelOperator && !channelItem.channelOperator) ||
          element.ChannelOperator === channelItem.channelOperator)
    );
    if (chDelivery && chDelivery.BounceBackData) {
      return (
        <button
          type="button"
          className="tooltip-btn finger w_p_action w_p_action_tooltip"
          style={{
            verticalAlign: "middle",
            margin: "0px 5px",
          }}
          title={translate("ShowBouncebackReasons")}
          onClick={(e) => showBBsReason(chDelivery.BounceBackData)}
        >
          <i className="fa fa-info-circle" />
        </button>
      );
    }
    return null;
  };

  const senderReceiverList = (items) => {
    return (items || []).map((item, index) => {
      return (
          <tr key={ index }>
            <td data-title="Name">
              { translate(item.name) }
            </td>
            <td data-title="Value">
              { item.value }
            </td>
          </tr>
      );
    });
  };

  const channelList = (items, docnodeid, docIndex) => {
    return (items || []).map((item, index) => {
      return (
        <tr key={index}>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="Channel"
          >
            <div
              style={{
                float: "left",
                margin: "3px 3px 0px 0px",
              }}
            >
              {item.channel}{" "}
              {item.channelOperator ? ` (${item.channelOperator})` : ""}
            </div>
            {getBounceBackWarning(item, docIndex)}
            {item.channel && item.channel.toLowerCase() === "ipost" && (
              <>
                <button
                  className="tooltip-btn"
                  data-tip
                  data-place="bottom"
                  data-type="info"
                  data-effect="solid"
                  data-for="activationTip-ipost"
                >
                  <i
                    className="fa fa-question-circle"
                    style={{
                      padding: "0px 7px 0px",
                      fontSize: "0.8em",
                    }}
                  />
                </button>
                <ReactTooltip className="customeTheme" id="activationTip-ipost">
                  <div>
                    <p>{translate("iPostServiceMessage")}</p>
                  </div>
                </ReactTooltip>
              </>
            )}{" "}
            {item.actualchannels && item.actualchannels.length && (
              <div
                style={{
                  float: "left",
                  margin: "3px 3px 0px 0px",
                }}
              >
                {"(" + item.actualchannels.join(", ") + ")"}
              </div>
            )}
          </td>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="Last update"
          >
            {item.lasttimestamp
              ? moment
                  .utc(item.lasttimestamp, moment.ISO_8601)
                  .format("DD-MM-YYYY HH:mm:ss")
              : "n/a"}
          </td>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="Status"
            className={"ch-status-" + item.status}
          >
            <div style={{ float: "left" }}>
              {translate(item.status)}
              {item.status === "BounceBack" && item.bb && item.bb.chto && (
                <span style={{ marginLeft: "0.5em" }}>
                  {`(${item.bb.chto}`}{" "}
                  {item.bb.chtooperator ? ` (${item.bb.chtooperator})` : ""})
                </span>
              )}
            </div>
            {item.bb && item.bb.rcode && item.bb.rmsg && (
              <>
                <button
                  className="tooltip-btn"
                  style={{
                    marginTop: "-6px",
                  }}
                  data-tip
                  data-place="bottom"
                  data-type="info"
                  data-effect="solid"
                  data-for={`activationTip-bb-reason-${docnodeid}-${item.channel}-${index}`}
                >
                  <i
                    className="fa fa-info-circle"
                    style={{
                      padding: "0 7px",
                      fontSize: "0.8em",
                    }}
                  />
                </button>
                <ReactTooltip
                  className="customeTheme"
                  id={`activationTip-bb-reason-${docnodeid}-${item.channel}-${index}`}
                >
                  <div>
                    <strong>{translate("Code")}: </strong>
                    {item.bb.rcode}
                    <br />
                    <strong>{translate("Reason")}: </strong>
                    {item.bb.rmsg}
                  </div>
                </ReactTooltip>
              </>
            )}
            <div>
              {getChannelDelayIcon(item.delayProbability, docnodeid, index)}
            </div>
            {item.crd && (
              <>
                <button
                  className="tooltip-btn"
                  style={{
                    marginTop: "-6px",
                  }}
                  data-tip
                  data-place="bottom"
                  data-type="info"
                  data-effect="solid"
                  data-for={`activationTip-crd-${docnodeid}-${item.channel}-${index}`}
                >
                  <i
                    className="fa fa-question-circle"
                    style={{
                      padding: "0 7px",
                      fontSize: "0.8em",
                    }}
                  />
                </button>
                <ReactTooltip
                  className="customeTheme"
                  id={`activationTip-crd-${docnodeid}-${item.channel}-${index}`}
                >
                  <div>
                    <strong>{translate("Removed by")}: </strong>
                    {item.crd.userName}
                    <br />
                    <strong>{translate("Date")}: </strong>
                    {item.crd.timeStamp
                      ? moment
                          .utc(item.crd.timeStamp, moment.ISO_8601)
                          .format("DD-MM-YYYY HH:mm:ss")
                      : "n/a"}
                    <br />
                    <strong>{translate("Reason")}: </strong>
                    {item.crd.reason}
                  </div>
                </ReactTooltip>
              </>
            )}
            {item.uErr && item.uErr.message && (
              <>
                <button
                  className="tooltip-btn"
                  style={{
                    marginTop: "-6px",
                  }}
                  data-tip
                  data-place="bottom"
                  data-type="info"
                  data-effect="solid"
                  data-for={`activationTip-uErr-${docnodeid}-${item.channel}-${index}`}
                >
                  <i
                    className="fa fa-exclamation-circle"
                    style={{
                      padding: "0 7px",
                      fontSize: "0.8em",
                    }}
                  />
                </button>
                <ReactTooltip
                  className="customeTheme"
                  id={`activationTip-uErr-${docnodeid}-${item.channel}-${index}`}
                >
                  <div>{item.uErr.message}</div>
                </ReactTooltip>
              </>
            )}
          </td>
          <td>
            {item.bsts &&
              item.bsts.length > 0 &&
              item.bsts.map((bst, bstIndex) => {
                return (
                  <span key={bstIndex}>
                    <span
                      style={bst.n ? { color: "red" } : {}}
                      data-tip
                      data-place="bottom"
                      data-type="info"
                      data-effect="solid"
                      data-for={`channel-bsts-${docnodeid}-${item.channel}-${bstIndex}-${index}`}
                    >
                      <i
                        className={`fa fa-${(
                          tagsIcons[bst.st.toLowerCase()] || "user-check"
                        ).replace("fa-", "")}`}
                        style={{ padding: "0 5px" }}
                      />
                      <span
                        style={{
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                      >
                        {bst.st}
                      </span>
                    </span>
                    {bstIndex < item.bsts.length - 1 ? ", " : ""}
                    <ReactTooltip
                      key={`tip-${bstIndex}`}
                      className="customeTheme"
                      id={`channel-bsts-${docnodeid}-${item.channel}-${bstIndex}-${index}`}
                    >
                      <div>
                        <strong>{translate("Status")}:</strong>{" "}
                        <span
                          style={{
                            fontWeight: "700",
                            textTransform: "uppercase",
                          }}
                        >
                          {bst.st}
                        </span>
                        <br />
                        <strong>{translate("Date")}:</strong>{" "}
                        {bst.ts
                          ? moment
                              .utc(bst.ts, moment.ISO_8601)
                              .format("DD-MM-YYYY HH:mm:ss")
                          : "n/a"}
                      </div>
                    </ReactTooltip>
                  </span>
                );
              })}
          </td>
        </tr>
      );
    });
  };

  const instanceList = (index) => {
    return (docsInstances[index] || []).map((item, indx) => {
      return (
        <tr key={indx}>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="Service"
          >
            {item.servicename}
          </td>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="End time"
          >
            {item.endtime
              ? moment
                  .utc(item.endtime, moment.ISO_8601)
                  .format("DD-MM-YYYY HH:mm:ss")
              : "n/a"}
          </td>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="&nbsp;"
            className="w_p_action_tooltip w_p_action_sub"
            data-action="open_instance_mod"
            onClick={(e) => {
              handleOpenFullEventClick(e, item.eventid);
            }}
            data-toggle="btnToolTip"
            data-placement="bottom"
            data-container="body"
            title={translate("View content")}
          >
            <button
              className="btn btn-secondary btn-sm btn-sm"
              style={{ fontSize: "13px" }}
            >
              <i className="fa fa-folder-open" aria-hidden="true" />
            </button>
          </td>
        </tr>
      );
    });
  };

  const batchList = (items, doc) => {
    return (items || []).map((item, index) => {
      return (
        <tr key={index}>
          <td
            style={{ height: "36px", fontWeight: "400", fontSize: "1em" }}
            data-title="Batch"
          >
            {item}
          </td>
          <td style={{ paddingLeft: "5rem" }}>
            <span
              data-tip
              data-place="bottom"
              data-type="info"
              data-effect="solid"
              data-for="oldDocFilesTip"
            >
              <Button
                color="secondary"
                disabled={!!isOldDocument(doc)}
                className="btn-posti-default"
                onClick={(e) => handleOpenEndpointsClick(e, doc, "batch", item)}
              >
                {translate("View Endpoints")}
              </Button>
            </span>
            <span
              data-tip
              data-place="bottom"
              data-type="info"
              data-effect="solid"
              data-for="oldDocFilesTip"
            >
              <Button
                style={{ marginLeft: "1em" }}
                disabled={!!isOldDocument(doc)}
                color="secondary"
                className="btn-posti-default"
                onClick={(e) =>
                  handleOpenDocsBucketClick(e, doc, "batch", item)
                }
              >
                {translate("View batch DOB")}
              </Button>
            </span>
          </td>
        </tr>
      );
    });
  };

  var atLeastOneRowHasEBID = false;
  return (
    <div className="col-12" style={{ padding: "0px" }}>
      <div
        className={
          "row documents-wrapper" + (atLeastOneRowHasEBID ? "" : " no-doc-ebid")
        }
        style={{ margin: "0px" }}
      >
        <table
          className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
          cellSpacing="0"
          style={{ border: "0px", padding: "0px" }}
        >
          <thead
            style={{ background: "#3A4A57", color: "#fff" }}
            className="grids_header"
          >
            <tr style={{ fontSize: ".8rem" }}>
              <th className="text-center hidden-sm-screen">
                <div className="header-container" style={{ display: "block" }}>
                  <ColumnToggleMenu
                    currentColumn="generic"
                    atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                  />
                </div>
              </th>
              {!isSender && <th className="text-center hidden-sm-screen" />}
              {!(hiddenColumns || []).includes("customer") && !isExternalUser && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Customer")}</div>
                    <ColumnToggleMenu
                      currentColumn="customer"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("platform") && !isExternalUser && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Platform")}</div>
                    <ColumnToggleMenu
                      currentColumn="platform"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("documentNumber") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("DocumentNumber")}</div>
                    <ColumnToggleMenu
                      currentColumn="documentNumber"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("docid") && !isExternalUser && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("DocumentId")}</div>
                    <ColumnToggleMenu
                      currentColumn="docid"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("ebid") && atLeastOneRowHasEBID && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">EBID</div>
                    <ColumnToggleMenu
                      currentColumn="ebid"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("flows") && (
                <th className="text-center">
                  <div className="header-container">
                    <div className="title">{translate("Flow")}</div>
                    <ColumnToggleMenu
                      currentColumn="flows"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("flowName") && (
                <th className="text-center">
                  <div className="header-container">
                    <div className="title">{translate("flowName")}</div>
                    <ColumnToggleMenu
                      currentColumn="flowName"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("sender") && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Sender")}</div>
                    <ColumnToggleMenu
                      currentColumn="sender"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("senderName") && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Sender Name")}</div>
                    <ColumnToggleMenu
                      currentColumn="senderName"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("receiver") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Receiver")}</div>
                    <ColumnToggleMenu
                      currentColumn="receiver"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("receiverName") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("Receiver Name")}</div>
                    <ColumnToggleMenu
                      currentColumn="receiverName"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("channels") && (
                <th className="hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Channels")}</div>
                    <ColumnToggleMenu
                      currentColumn="channels"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("arrivalTime") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("ArrivalTime")}</div>
                    <ColumnToggleMenu
                      currentColumn="arrivalTime"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("lastUpdate") && (
                <th>
                  <div className="header-container">
                    <div className="title">{translate("LastUpdate")}</div>
                    <ColumnToggleMenu
                      currentColumn="lastUpdate"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              {!(hiddenColumns || []).includes("status") && (
                <th className="text-center hidden-sm-screen">
                  <div className="header-container">
                    <div className="title">{translate("Status")}</div>
                    <ColumnToggleMenu
                      currentColumn="status"
                      atLeastOneRowHasEBID={atLeastOneRowHasEBID}
                    />
                  </div>
                </th>
              )}
              <th
                className="text-center hidden-sm-screen"
                style={{ whiteSpace: "nowrap" }}
              />
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
            {docs.map((doc, index) => {
              const senderReceiverData = [
                { name: 'Sender address', value: doc.senderAddr },
                { name: 'Sender electronic address', value: doc.senderEAddr },
                { name: 'Receiver address', value: doc.receiverAddr },
                { name: 'Receiver electronic address', value: doc.receiverEAddr }
              ].filter(item => item.value);

              return [
                <tr
                  key={doc.docnodeid}
                  className={
                    "row_tr row-status-" +
                    doc.status +
                    (doc.mode === "test" ? " mode_color" : "") +
                    (doc.isActive ? " active-row" : "") +
                    (doc.expanded ? " expanded" : "")
                  }
                  onClick={(e) => {
                    handleRowClick(e, doc, index);
                  }}
                >
                  <td
                    style={{ padding: ".1rem" }}
                    className="text-center hidden-sm-screen"
                  >
                    <span
                      className="fa fa-angle-double-down"
                      style={{ fontSize: "1.3em" }}
                    />
                  </td>
                  {!isSender && (
                    <td
                      style={{ padding: ".1rem", minWidth: "6rem" }}
                      className="text-center hidden-sm-screen"
                    >
                      {!isExternalUser && (
                        <button
                          className="btn btn-secondary"
                          onClick={() => handleOpenFlow(doc)}
                          style={{ lineHeight: ".9" }}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          data-container="body"
                          disabled={!!isOldDocument(doc)}
                          title={
                            isOldDocument(doc)
                              ? translate("OldDocFilesTip")
                              : translate("Open Flow")
                          }
                        >
                          <span className="fa fa-random" />
                        </button>
                      )}
                      <button
                        className="btn btn-secondary"
                        onClick={() => handleOpenFiles(doc)}
                        style={{ lineHeight: ".9", marginLeft: "5px" }}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        data-container="body"
                        title={translate("Navigate to file")}
                      >
                        <span className="fa fa-file" />
                      </button>
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("customer") &&
                    !isExternalUser && (
                      <td className="hidden-sm-screen">{doc.customer}</td>
                    )}
                  {!(hiddenColumns || []).includes("platform") &&
                    !isExternalUser && (
                      <td className="hidden-sm-screen">{doc.platform}</td>
                    )}
                  {!(hiddenColumns || []).includes("documentNumber") && (
                    <td className="doc-documentNr-column">
                      <div
                        className="documentNr-content"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {doc.hasRepo && (
                          <button
                            className="tooltip-btn"
                            onClick={() => {
                              handleOpenReposLink(doc);
                            }}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            data-container="body"
                            title="Open Repository Link"
                          >
                            <i
                              className="fa fa-file-pdf"
                              style={{ padding: "0 5px" }}
                            />
                          </button>
                        )}
                        <div className="finger w_p_action">
                          {doc.mode === "test" && (
                            <span>
                              <i>[TEST]</i>{" "}
                            </span>
                          )}{" "}
                          {doc.documentNr || (
                            <i>{`[${translate("Not defined")}]`}</i>
                          )}
                        </div>
                        <button
                          className="btn btn-secondary open-flow ls-screen-hidden"
                          onClick={() => handleOpenFlow(doc)}
                          style={{ lineHeight: ".9" }}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          data-container="body"
                          title="Open Flow"
                          data-original-title="Open Flow"
                        >
                          <span className="fa fa-random" />
                        </button>
                      </div>
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("docid") &&
                    !isExternalUser && (
                      <td className="hidden-sm-screen">{doc.docid}</td>
                    )}
                  {!(hiddenColumns || []).includes("ebid") && (
                    <td className="ebid-data-cell hidden-sm-screen">
                      {doc.ebid}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("flows") && (
                    <td className="text-center doc-project-column">
                      {doc.project}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("flowName") && (
                    <td className="hidden-sm-screen">{doc.flowName}</td>
                  )}
                  {!(hiddenColumns || []).includes("sender") && (
                    <td data-title="Sender" className="hidden-sm-screen">
                      {doc.sender || <i>{`[${translate("Not defined")}]`}</i>}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("senderName") && (
                    <td data-title="Sender" className="hidden-sm-screen">
                      {doc.senderName || (
                        <i>{`[${translate("Not defined")}]`}</i>
                      )}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("receiver") && (
                    <td data-title="Receiver" className="doc-receiver-column">
                      {doc.receiver || <i>{`[${translate("Not defined")}]`}</i>}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("receiverName") && (
                    <td data-title="Receiver" className="doc-receiver-column">
                      {doc.receiverName || (
                        <i>{`[${translate("Not defined")}]`}</i>
                      )}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("channels") && (
                    <td className="hidden-sm-screen">
                      {doc.deliverydata ? (
                        doc.deliverydata.length > 1 ? (
                          <u>{translate("Multiple")}</u>
                        ) : (
                          doc.deliverydata[0] && doc.deliverydata[0].channel
                        )
                      ) : (
                        ""
                      )}
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("arrivalTime") && (
                    <td data-title="Arrival time" className="doc-date-column">
                      <span className="ls-screen-hidden">
                        {doc.fileArrivalTs
                          ? moment
                              .utc(doc.fileArrivalTs, moment.ISO_8601)
                              .format("DD.MM.YYYY")
                          : "n/a"}
                      </span>
                      <span className="hidden-sm-screen">
                        {doc.fileArrivalTs
                          ? moment
                              .utc(doc.fileArrivalTs, moment.ISO_8601)
                              .format("DD-MM-YYYY HH:mm:ss")
                          : "n/a"}
                      </span>
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("lastUpdate") && (
                    <td data-title="Last update" className="doc-date-column">
                      <span className="ls-screen-hidden">
                        {doc.timestamp
                          ? moment
                              .utc(doc.timestamp, moment.ISO_8601)
                              .format("DD.MM.YYYY")
                          : "n/a"}
                      </span>
                      <span className="hidden-sm-screen">
                        {doc.timestamp
                          ? moment
                              .utc(doc.timestamp, moment.ISO_8601)
                              .format("DD-MM-YYYY HH:mm:ss")
                          : "n/a"}
                      </span>
                      <span className="fa fa-angle-double-down expand-icon ls-screen-hidden" />
                    </td>
                  )}
                  {!(hiddenColumns || []).includes("status") && (
                    <td className="hidden-sm-screen" style={{ width: "140px" }}>
                      <div style={{ display: "flex", maxWidth: '100%' }}>
                        <span
                            style={ {
                              textTransform: "uppercase",
                              paddingRight: "0.5em",
                              display: 'inline-block'
                            } }
                            data-tip
                            data-place="bottom"
                            data-type="info"
                            data-effect="solid"
                            data-for={ `DocStatusTip-${ doc.docnodeid }` }
                            className={ "tag-status-label status-" + doc.status }
                        >
                          <div style={ { float: "left" } }>
                            { translate(doc.status) }
                          </div>
                          { getDeliveryButtonCmp(doc) }
                        </span>
                        { doc.noMData && (
                            <>
                              <button
                                  type="button"
                                  className="tooltip-btn"
                                  style={{
                                    verticalAlign: "middle",
                                    margin: "0px 5px",
                                    fontSize: "16px",
                                  }}
                                  data-tip
                                  data-place="bottom"
                                  data-type="info"
                                  data-effect="solid"
                                  data-for={`fileRejectionData-${ doc.uniqueId }`}
                              >
                                <i className="fa fa-exclamation-triangle" />
                              </button>
                              <ReactTooltip
                                  className="customeTheme"
                                  id={`fileRejectionData-${ doc.uniqueId }`}
                              >
                                { translate('HasIncomplete') }
                              </ReactTooltip>
                            </>
                        ) }
                      </div>
                      {!isExternalUser &&
                        doc.status === "Removed" &&
                        !!doc.fileRemovingData && (
                          <ReactTooltip
                            className="customeTheme"
                            id={`DocStatusTip-${doc.docnodeid}`}
                          >
                            <div style={{ textAlign: "left" }}>
                              <div>
                                <strong>{translate("Removed by")}: </strong>
                                {doc.fileRemovingData["userName"]}
                              </div>
                              <div>
                                <strong>{translate("Date")}: </strong>
                                {doc.fileRemovingData["timeStamp"]
                                  ? moment
                                      .utc(
                                        doc.fileRemovingData["timeStamp"],
                                        moment.ISO_8601
                                      )
                                      .format("DD.MM.YYYY")
                                  : "n/a"}
                              </div>
                              <div>
                                <strong>{translate("Reason")}: </strong>
                                {doc.fileRemovingData["reason"]}
                              </div>
                            </div>
                          </ReactTooltip>
                        )}
                    </td>
                  )}
                  <td style={{ textAlign: "center", padding: 0 }}>
                    {doc.bst && (
                      <>
                        <span
                          style={doc.bst.n ? { color: "red" } : {}}
                          data-tip
                          data-place="bottom"
                          data-type="info"
                          data-effect="solid"
                          data-for={`doc-bst-${doc.docnodeid}`}
                        >
                          <i
                            className={`fa fa-${(
                              tagsIcons[doc.bst.st.toLowerCase()] ||
                              "user-check"
                            ).replace("fa-", "")}`}
                            style={{ padding: "0 5px" }}
                          />
                        </span>
                        <ReactTooltip
                          className="customeTheme"
                          id={`doc-bst-${doc.docnodeid}`}
                        >
                          <div>
                            <strong>{translate("Status")}:</strong>{" "}
                            <span
                              style={{
                                fontWeight: "700",
                                textTransform: "uppercase",
                              }}
                            >
                              {doc.bst.st}
                            </span>
                            <br />
                            <strong>{translate("Date")}:</strong>{" "}
                            {doc.bst.ts
                              ? moment
                                  .utc(doc.bst.ts, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </div>
                        </ReactTooltip>
                      </>
                    )}
                    {!isExternalUser && !!isOldDocument(doc) && (
                      <span>
                        <button
                          type="button"
                          className="tooltip-btn"
                          style={{
                            verticalAlign: "middle",
                            fontSize: "16px",
                          }}
                          data-tip
                          data-place="bottom"
                          data-type="info"
                          data-effect="solid"
                          data-for="oldDocFilesTip"
                        >
                          <i className="fa fa-hourglass-end" />
                        </button>
                        <ReactTooltip
                          className="customeTheme"
                          id="oldDocFilesTip"
                        >
                          {translate("OldDocFilesTip")}
                        </ReactTooltip>
                      </span>
                    )}
                    { doc.docErrorText && (
                      <span>
                        <button
                            type="button"
                            className="tooltip-btn"
                            data-place="bottom"
                            data-effect="solid"
                            value={ doc.docErrorText }
                            style={{
                              verticalAlign: "middle",
                              padding: "0 4px",
                              fontSize: "16px",
                            }}
                            onClick={ handleDocErrorText }
                        >
                          <i className="fa fa-exclamation-circle" />
                        </button>
                      </span>
                    )}
                  </td>
                </tr>,
                doc.expanded && (
                  <tr
                    key={"sub_" + doc.docnodeid}
                    className={"w_subtable_id row-status-" + doc.status}
                  >
                    <td colSpan="100%">
                      <div
                        className="row panel panel-default"
                        style={{
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "80%",
                        }}
                      >
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: docsActiveTabs[index] === "0",
                                })}
                                onClick={() => {
                                  toggle("0", index);
                                }}
                              >
                                {translate("Channels")} (
                                {(doc.deliverydata || []).length})
                              </NavLink>
                            </NavItem>
                            { senderReceiverData.length > 0 && (
                                <NavItem>
                                  <NavLink
                                      className={ classnames({ active: docsActiveTabs[index] === '1' }) }
                                      onClick={ () => {
                                        toggle('1', index);
                                      } }
                                  >
                                    { translate('Additional info') }
                                  </NavLink>
                                </NavItem>
                            ) }
                            {!isExternalUser && !isOldDocument(doc) && (
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: docsActiveTabs[index] === "2",
                                  })}
                                  onClick={() => {
                                    toggle("2", index);
                                  }}
                                >
                                  {translate("Instances")} (
                                  {(docsInstances[index] || []).length})
                                </NavLink>
                              </NavItem>
                            )}
                            {!isExternalUser && (
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: docsActiveTabs[index] === "3",
                                  })}
                                  onClick={() => {
                                    toggle("3", index);
                                  }}
                                >
                                  {translate("Batches")} (
                                  {(doc.batches || []).length})
                                </NavLink>
                              </NavItem>
                            )}
                            {!isExternalUser && (
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active: docsActiveTabs[index] === "4",
                                  })}
                                  onClick={() => {
                                    toggle("4", index);
                                  }}
                                >
                                  {translate("Technical")}
                                </NavLink>
                              </NavItem>
                            )}
                          </Nav>
                          <TabContent activeTab={docsActiveTabs[index]}>
                            <TabPane tabId="0">
                              <table
                                className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                                cellSpacing="0"
                                style={{ border: "0px", padding: "10px" }}
                              >
                                <thead className="grids_header">
                                  <tr>
                                    <th>{translate("Channel")}</th>
                                    <th>{translate("LastUpdate")}</th>
                                    <th>{translate("Status")}</th>
                                    <th>{translate("Receiver status")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {channelList(
                                    doc.deliverydata,
                                    doc.docnodeid,
                                    index
                                  )}
                                </tbody>
                              </table>
                            </TabPane>
                            { senderReceiverData.length > 0 && (
                                <TabPane tabId="1">
                                  <table
                                      className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                                      cellSpacing="0"
                                      style={ { border: '0px', padding: '10px' } }
                                  >
                                    <thead className="grids_header">
                                    <tr>
                                      <th>{ translate('Name') }</th>
                                      <th>{ translate('Value') }</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    { senderReceiverList(senderReceiverData) }
                                    </tbody>
                                  </table>
                                </TabPane>
                            ) }
                            {!isExternalUser && !isOldDocument(doc) && (
                              <TabPane tabId="2">
                                <table
                                  className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                                  cellSpacing="0"
                                  style={{ border: "0px", padding: "10px" }}
                                >
                                  <thead className="grids_header">
                                    <tr>
                                      <th>{translate("Service")}</th>
                                      <th>{translate("EndTime")}</th>
                                      <th>{}</th>
                                    </tr>
                                  </thead>
                                  <tbody>{instanceList(index)}</tbody>
                                </table>
                              </TabPane>
                            )}
                            {!isExternalUser && (
                              <TabPane tabId="3">
                                <table
                                  className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                                  cellSpacing="0"
                                  style={{ border: "0px", padding: "10px" }}
                                >
                                  <thead className="grids_header">
                                    <tr>
                                      <th>{translate("Batch")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>{batchList(doc.batches, doc)}</tbody>
                                </table>
                              </TabPane>
                            )}
                            {!isExternalUser && (
                              <TabPane tabId="4">
                                <table
                                  className="table-bordered table-condensed table-hover table-sm panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12 col-lg-offset-0"
                                  cellSpacing="0"
                                  style={{ border: "0px", padding: "10px" }}
                                >
                                  <thead className="grids_header">
                                    <tr>
                                      <th>{translate("Technical")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td style={{ paddingLeft: "5rem" }}>
                                        <span
                                          data-tip
                                          data-place="bottom"
                                          data-type="info"
                                          data-effect="solid"
                                          data-for="oldDocFilesTip"
                                        >
                                          <Button
                                            color="secondary"
                                            disabled={!!isOldDocument(doc)}
                                            className="btn-posti-default"
                                            onClick={(e) =>
                                              handleOpenEndpointsClick(
                                                e,
                                                doc,
                                                "doc"
                                              )
                                            }
                                          >
                                            {translate("View Endpoints")}
                                          </Button>
                                        </span>
                                        <span
                                          data-tip
                                          data-place="bottom"
                                          data-type="info"
                                          data-effect="solid"
                                          data-for="oldDocFilesTip"
                                        >
                                          <Button
                                            style={{ marginLeft: "1em" }}
                                            color="secondary"
                                            disabled={!!isOldDocument(doc)}
                                            className="btn-posti-default"
                                            onClick={(e) =>
                                              handleOpenDocsBucketClick(
                                                e,
                                                doc,
                                                "doc"
                                              )
                                            }
                                          >
                                            {translate("View doc's DOB")}
                                          </Button>
                                        </span>
                                        <Button
                                          style={{ marginLeft: "1em" }}
                                          color="secondary"
                                          className="btn-posti-default"
                                          onClick={(e) =>
                                            handleShowParametersClick(
                                              e,
                                              doc,
                                              true
                                            )
                                          }
                                        >
                                          {translate("Show parameters")}
                                        </Button>
                                        <Button
                                          style={{ marginLeft: "1em" }}
                                          color="secondary"
                                          className="btn-posti-default"
                                          onClick={(e) =>
                                            handleShowParametersClick(
                                              e,
                                              doc,
                                              false
                                            )
                                          }
                                        >
                                          {translate("Show parked doc")}
                                        </Button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </TabPane>
                            )}
                          </TabContent>
                        </div>
                        {isOldDocument(doc) && (
                          <ReactTooltip
                            className="customeTheme"
                            id="oldDocFilesTip"
                          >
                            {translate("OldDocFilesTip")}
                          </ReactTooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                ),
              ];
            })}
          </tbody>
        </table>
      </div>
      <Modal
        isOpen={!!fileBBReason}
        toggle={closeFileBBReasonsModel}
        zIndex={"99999999999"}
        style={{ maxHeight: "calc(100vh - 60px)" }}
        contentClassName="fileBB-modal-content"
      >
        <ModalBody style={{ overflow: "auto" }}>{fileBBReason}</ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="switchBtn"
            style={{ width: "100px" }}
            onClick={closeFileBBReasonsModel}
          >
            {translate("Close")}
          </button>
        </ModalFooter>
      </Modal>
      <Modal
          isOpen={ !!docError }
          toggle={ closeDocErrorTextModal }
          zIndex={ '99999999999' }
          style={ { maxHeight: 'calc(100vh - 60px)' } }
          contentClassName="fileBB-modal-content"
      >
        <ModalBody style={ { overflow: 'auto' } }>{ docError }</ModalBody>
        <ModalFooter className="text-center">
          <button
              type="button"
              className="switchBtn"
              style={ { width: '100px' } }
              onClick={ closeDocErrorTextModal }
          >
            { translate('Close') }
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

function mapStateToProps(state) {
  const { documents, locale, config } = state;
  const { docsActiveTabs, docsInstances, docDeliveryData } = config;
  return {
    hiddenColumns: documents.hiddenColumns,
    docsActiveTabs,
    docsInstances,
    docDeliveryData,
    translate: getTranslate(locale),
    tagsIcons: config.tagsIcons,
  };
}

const connectedDocumentsGrid = connect(mapStateToProps)(
  withRouter(DocumentsGrid)
);
export { connectedDocumentsGrid as DocumentsGrid };
